import { useNavigate, useParams, Link } from "react-router-dom";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";
import Spacer from "./Spacer";
import Visibility from "./utils/Visibility";
import { indexStore } from "../store/indexStore";
import { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
import { Skeleton } from "./ui/skeleton";
import RestaurantModel from "../Models/RestaurantModel";

type HeaderProps = {
  noBack?: boolean;
  backgroundColorfull?: boolean;
  url?: string;
  
};
export const Header = ({ noBack = false, ...props }: HeaderProps) => {
  // ...
  const [scroll, setScroll] = useState(false);
  const {
    name,
    restaurant,
    loading,
    // lang, changeLangBottomSheet
  } = indexStore();
  // const { t } = useTranslation();

  const navigate = useNavigate();
  const params = useParams();
  useEffect(() => {
    window.addEventListener("scroll", () => {});
    const handleScroll = () => {
      setScroll(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`flex items-center w-full p-4 bg-background z-10 sticky shrink-0 top-0 ${
        scroll ? "scroll bg-background" : ""
      } ${
        props.backgroundColorfull
          ? "bg-primary text-onPrimary shadow-none border-none"
          : ""
      }`}
    >
      {/* Back Button (Left side) */}
      <Visibility visible={!noBack}>
        <button
          className={`text-lg cursor-pointer text-onBackground ${
            props.backgroundColorfull ? "bg-primary text-onPrimary" : ""
          }`}
          onClick={() => {
            if (props.url) {
              return navigate(props.url);
            } else navigate(-1);
          }}
        >
          {localStorage.getItem("Lang") === "ar" ? (
            <FaAngleRight />
          ) : (
            <FaAngleLeft />
          )}
        </button>
      </Visibility>
      <Visibility visible={noBack}>
        <Spacer width={18} />
      </Visibility>

      {/* Centered Link (Middle element) */}
      <Visibility visible={!loading}>
        <Link
          className={`text-primary font-bold text-xl flex-grow uppercase tracking-widest text-center ${
            props.backgroundColorfull ? "!text-onPrimary" : ""
          }`}
          to={`/${params.domain}/${params.branch_id}`}
        >
          {restaurant[name as keyof RestaurantModel]}
        </Link>
      </Visibility>

      <Visibility visible={loading}>
        <div className="flex flex-grow items-center justify-center border-none shadow-none">
          <Skeleton className="w-1/2 h-8 " />
        </div>
      </Visibility>

      <Visibility visible={noBack}>
        <Spacer width={30} />
      </Visibility>
      {/* <SideSheet backgroundColorfull={props.backgroundColorfull} /> */}
    </div>
  );
};
